<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="back-container borderless">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
    </div>

    <div class="form-column borderless">
      <div class="form-group" style="width: 100%;">
        <label>Firstname</label>
        <input type="text" [(ngModel)]="firstname" [disabled]="isEdit" />
      </div>

      <div class="form-group" style="width: 100%;">
        <label>Surname</label>
        <input type="text" [(ngModel)]="surname" [disabled]="isEdit" />
      </div>


      <div class="form-group" style="width: 100%;">
        <label>PIN</label>
        <input type="password" name="password1" [(ngModel)]="password" placeholder="unchanged" autocomplete="off" />
        </div>
        
        <div class="form-group" style="width: 100%;">
          <label>Confirm PIN</label>
          <input type="password" name="password2" [(ngModel)]="password2" placeholder="unchanged" autocomplete="off" />
        </div>
        
        <div  style="width: 100%;display: flex;flex-direction: row;">
          <div class="form-group" style="width: 25%;">
            <label>Signature</label>
            <input type="file" class="btn btn-primary" style="width: 15rem;min-height: 50px;min-width: 15rem;" name="sig"(change)="uploadFile($event)" />
            <label class="small" style="font-size:12;font-style:italic">Please make sure the file size is less than 5mb</label>
            <label class="small" style="font-size:12;font-style:italic">Please make sure the image dimensions are 320 by 85 for optimal viewing on the reports</label>
          </div>
        
          <div  
           style="width: 50%;">
          <img *ngIf="imageSource != null || imageSource != undefined" [src]="imageSource" width="320" height="85">
        </div>
        </div>
        </div>
        
        <div class="btn-container">
          <button *ngIf="id != null && expired" class="btn btn-secondary" (click)="delete()">Reactivate</button>
          <button *ngIf="id != null && !expired" class="btn btn-secondary" (click)="delete()">Deactivate</button>
          <div class="spacer" *ngIf="id == null"></div>
          <button class="btn btn-primary" (click)="save()">Save</button>
        
        </div>

  </article>
</div>